document.addEventListener('DOMContentLoaded', function () {
  const switchWrapper = document.querySelector('[data-layout-switch]');
  if (!switchWrapper) {
    console.error('Layout switch wrapper not found');
    return;
  }

  const buttons = switchWrapper.querySelectorAll('[data-btn-as-a]');
  const dataItems = switchWrapper.getAttribute('data-items') || '';
  const itemsArray = dataItems.split('.');

  const breakpoints = {
    mobile: itemsArray[0] || null,
    tablet: itemsArray.length === 3 ? itemsArray[1] : null,
    desktop: itemsArray.length === 3 ? itemsArray[2] : (itemsArray[1] || null),
  };

  const screenSizes = {
    mobile: 767,
    tablet: 1023,
    desktop: Infinity,
  };

  let productGrid = document.querySelector('.product-grid');
  let currentBreakpoint = null;
  let isResizing = false;
  let isScrolling = false;
  let scrollTimeout;

  const cleanAllGridClasses = () => {
    if (!productGrid) {
      console.error('Product grid not found');
      return;
    }

    // Remove all grid classes that the layout switch can apply
    const classesToRemove = [
      'grid--list-view-col',
      'grid--1-col-tablet-down',
      'grid--2-col-tablet-down',
      'grid--1-col-tablet',
      'grid--2-col-tablet',
      'grid--3-col-tablet',
      'grid--4-col-tablet',
      'grid--1-col-desktop',
      'grid--2-col-desktop',
      'grid--3-col-desktop',
      'grid--4-col-desktop',
      'grid--5-col-desktop',
      'grid--6-col-desktop'
    ];

    classesToRemove.forEach(className => {
      productGrid.classList.remove(className);
    });
  };

  const applyLayoutClass = (breakpoint, col) => {
    if (!productGrid) {
      console.error('Product grid not found');
      return;
    }

    cleanAllGridClasses();

    if (col === 'list-view') {
      productGrid.classList.add('grid--list-view-col');
    } else if (col) {
      let layoutClass = '';
      if (breakpoint === 'mobile') {
        layoutClass = `grid--${col}-col-tablet-down`;
      } else if (breakpoint === 'tablet') {
        layoutClass = `grid--${col}-col-tablet`;
      } else if (breakpoint === 'desktop') {
        layoutClass = `grid--${col}-col-desktop`;
      }

      if (layoutClass) {
        productGrid.classList.add(layoutClass);
      }
    }
  };

  const getCurrentBreakpoint = () => {
    const width = window.innerWidth;
    if (width <= screenSizes.mobile) return 'mobile';
    if (width <= screenSizes.tablet) return 'tablet';
    return 'desktop';
  };

  const updateActiveButtons = (breakpoint, col) => {
    ['mobile', 'tablet', 'desktop'].forEach(bp => {
      const btnGroup = switchWrapper.querySelectorAll(`[data-breakpoint="${bp}"]`);
      btnGroup.forEach(btn => btn.classList.remove('is--active'));
    });

    const btnToActivate = switchWrapper.querySelector(`[data-breakpoint="${breakpoint}"][data-col="${col}"]`);
    if (btnToActivate) {
      btnToActivate.classList.add('is--active');
    }
  };

  const initializeLayout = () => {
    productGrid = document.querySelector('.product-grid'); // refresh reference
    if (!productGrid) {
      console.error('Product grid not found during initialization');
      return;
    }

    const breakpoint = getCurrentBreakpoint();
    const col = breakpoints[breakpoint];

    if (!col) {
      console.error('No column setting for breakpoint:', breakpoint);
      return;
    }

    applyLayoutClass(breakpoint, col);
    updateActiveButtons(breakpoint, col);
  };

  // Button click handler
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const breakpoint = button.getAttribute('data-breakpoint');
      const selectedCol = button.getAttribute('data-col');
      const currentBreakpoint = getCurrentBreakpoint();

      if (breakpoint !== currentBreakpoint) {
        return;
      }

      applyLayoutClass(breakpoint, selectedCol);
      updateActiveButtons(breakpoint, selectedCol);
    });
  });

  // Run on initial load
  initializeLayout();
  currentBreakpoint = getCurrentBreakpoint();

  // Scroll detection for mobile devices
  const handleScroll = () => {
    isScrolling = true;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isScrolling = false;
    }, 150);
  };

  // Optimized window resize listener - only trigger on actual breakpoint changes
  let resizeTimeout;
  const handleResize = () => {
    // Don't handle resize during scrolling on mobile
    if (isScrolling && window.innerWidth <= screenSizes.mobile) {
      return;
    }

    if (isResizing) return;

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newBreakpoint = getCurrentBreakpoint();
      // Only reinitialize if the breakpoint actually changed
      if (newBreakpoint !== currentBreakpoint) {
        currentBreakpoint = newBreakpoint;
        initializeLayout();
      }
      isResizing = false;
    }, 750); // Increased timeout to reduce frequency on mobile
  };

  // Use passive event listeners for better performance
  window.addEventListener('resize', handleResize, { passive: true });
  window.addEventListener('scroll', handleScroll, { passive: true });

  // ✅ MutationObserver to detect changes to #ProductGridContainer
  const containerParent = document.querySelector('#ProductGridContainer');
  if (!containerParent) {
    console.error('ProductGridContainer not found');
    return;
  }

  let debounceTimeout;
  const debounceInitialize = () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      const newGrid = document.querySelector('.product-grid');
      if (newGrid) {
        initializeLayout(); // re-apply layout after grid reload
      }
    }, 300);
  };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Run debounce on *any* DOM update inside the grid wrapper
        debounceInitialize();
        break;
      }
    }
  });

  observer.observe(containerParent, {
    childList: true,
    subtree: false, // only direct children
  });
});
